import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

import Align from '@marvelapp/marvel-ui/align';
import Button from '@marvelapp/marvel-ui/button';
import Heading from '@marvelapp/marvel-ui/heading';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';

import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck';
import styles from './style/general.module.css';

export default function Cta({ heading, ctaLink }) {
  return (
    <div className={styles.cta}>
      <Align type="center">
        <Spacing size="l" position="bottom" type="margin">
          <Spacing size="m" sizeM="0" position="leftRight" type="padding">
            <MaxWidth value={760}>
              <Heading size="xxxl" weight="semibold" color="black">
                {heading}
              </Heading>
            </MaxWidth>
          </Spacing>
        </Spacing>
        <Link to={ctaLink}>
          <Button shape="rounded" kind="flat" size="large">
            Request a demo
          </Button>
        </Link>
      </Align>
    </div>
  );
}

Cta.propTypes = {
  heading: propTypeEmptyString,
  ctaLink: PropTypes.string,
};

Cta.defaultProps = {
  heading:
    'Challenge the industry norm and become a CX centric design leader with Marvel Enterprise.',
  ctaLink: '/enterprise/request-demo',
};



// WEBPACK FOOTER //
// ./src/components/modules/Cta/CtaDemo/index.js